import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function sdkVersionSettingStore(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SDK_VERSION_SETTING:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    default:
      return state;
  }
}
